"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _Row = _interopRequireDefault(require("../baseComponents/Row"));

var _Col = _interopRequireDefault(require("../baseComponents/Col"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Table = function Table(props) {
  var tableContent = props.tableContent,
      style = props.style,
      textAlign = props.textAlign,
      className = props.className,
      sortable = props.sortable,
      headerContent = props.headerContent,
      disabled = props.disabled,
      sort = props.sort,
      rest = _objectWithoutProperties(props, ["tableContent", "style", "textAlign", "className", "sortable", "headerContent", "disabled", "sort"]);

  var classes = (0, _classnames["default"])("table", className);
  var xs = 12 / headerContent.length;

  function selectColumn(event) {
    if (sortable) {
      var columns = document.getElementsByClassName("first-row");

      for (var i = 0; i < columns.length; i++) {
        columns[i].className = columns[i].className.replace(" selected", "");
      }

      var nextRow = document.getElementsByClassName("next-row");

      for (var _i = 0; _i < nextRow.length; _i++) {
        nextRow[_i].className = nextRow[_i].className.replace(" selected", "");
      }

      event.currentTarget.className += " selected";
      var cols = document.getElementsByClassName("col" + event.currentTarget.id);

      for (var _i2 = 0; _i2 < cols.length; _i2++) {
        cols[_i2].classList.add("selected");
      }
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style
  }, headerContent.length > 0 && /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    center: "xs",
    middle: "xs",
    className: "headerRow"
  }, headerContent.map(function (item, key) {
    return /*#__PURE__*/_react["default"].createElement(_Col["default"], _extends({
      xs: xs,
      className: (0, _classnames["default"])("first-row", sortable ? "sortable" : "", textAlign),
      onClick: function onClick(event) {
        return selectColumn(event);
      }
    }, props.onClick, {
      id: key,
      key: key
    }), sortable && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("icon-right", sort)
    }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-arrow"
    })), item, sortable && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("icon-left", sort)
    }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-arrow"
    })));
  })), tableContent != null && tableContent.map(function (dataItem, key) {
    return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
      center: "xs",
      middle: "xs",
      key: key,
      className: "bodyRow"
    }, dataItem.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: xs,
        key: index,
        className: (0, _classnames["default"])("next-row", textAlign, disabled && "disabled", "col".concat(index))
      }, item);
    }));
  })));
};

Table.propTypes = {
  tableContent: _propTypes["default"].array,
  headerContent: _propTypes["default"].array,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  textAlign: _propTypes["default"].oneOf(["", "text-align-left", "text-align-right"]),
  sortable: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  sort: _propTypes["default"].oneOf(["asc", "desc"])
};
Table.defaultProps = {
  tableContent: null,
  headerContent: [],
  className: "",
  style: {},
  textAlign: "",
  sortable: false,
  disabled: false,
  onClick: function onClick() {},
  sort: "desc"
};
var _default = Table;
exports["default"] = _default;